<template>
	<v-container fluid class="py-0 my-0">
		<v-row justify="center" class=" py-0 my-0">
			<v-col cols="12" class="py-0 my-0">

				<v-row justify="center" class=" py-0 my-0">
					<v-col cols="9" class="py-0 my-0">
						<v-alert
							border="left"
							color="primary"
							dense outlined text type="info">
							Αλλαγές επιτρέπονται στο διάστημα από {{$store.getters.homePageInformation.configuration.LibraryOrderFromDate}} έως {{$store.getters.homePageInformation.configuration.LibraryOrderToDate}}
						</v-alert>
					</v-col>
				</v-row>


				<v-row justify="center" class=" pt-0 mt-0">
					<v-col cols="9" class="pt-0 mt-0">
						<v-container fluid style="background-color: #3AA8C3 ">
							<v-row>
								<v-col cols="5" style="max-height: 52px" class="mb-2">
									<v-select :items="$store.getters.yearsInfo.yearsList" outlined dense height="25" color="black"
											  v-model="selectedYear" item-value="year" item-text="yearLabel" @change="changeYear($event)"
											  label="Ακαδ. Έτος"/>
								</v-col>

								<v-col cols="4" style="max-height: 52px" class="mb-2">
									<v-text-field outlined dense color="black" label="Αναζήτηση" append-icon="search"   v-model="search"></v-text-field>
								</v-col>

								<v-col cols="3" style="max-height: 52px">
									<v-btn @click="getExcel" style="border: 2px solid black"> Εξαγωγή Αρχείου<v-icon>mdi-file-excel</v-icon></v-btn>
								</v-col>

							</v-row>
						</v-container>

						<v-row cols="12">
							<v-col cols="12">
								<v-data-table :style="{width:'100%'}" :headers="headers" :items="costLimits"
										  :footer-props="{
                                                itemsPerPageOptions:[10,25,50],
                                                'items-per-page-text':'Ανά γραμμή',
                                                prevIcon: 'mdi-arrow-left-bold',
                                                nextIcon: 'mdi-arrow-right-bold',
                                            }" :search="search" class="black--text">
								<template v-slot:item="{ item, index }">
									<tr >
										<td class="black--text text-center d-sm-table-cell d-flex">{{ item.institutionName }}</td>
										<td class="black--text text-center d-sm-table-cell d-flex pl-8" >
											<div class="text-field-wrapper"><v-text-field style="max-width: 90px" class="centered-text" dense hide-details v-model="item.costLimit" hide-spin-buttons/></div>
										</td>
										<td class="black--text text-center d-sm-table-cell d-flex">{{ item.amountLimit }}</td>
										<td class="black--text text-center d-sm-table-cell d-flex">
											<v-tooltip right>
												<template v-slot:activator="{ on }">
													<v-btn :disabled="saveOrderLimitDisabledCondition(item.costLimit)" fab x-small v-on="on" @click="saveOrderLimit(item)" color="primary">
														<v-icon color="secondary">mdi-floppy</v-icon>
													</v-btn>
												</template>
												<span>Αποθήκευση</span>
											</v-tooltip>

											<v-tooltip right>
												<template v-slot:activator="{ on }">
													<v-btn class="ml-1" fab x-small v-on="on" @click="resetCostLimit(index)" color="primary">
														<v-icon color="secondary"> mdi-reply</v-icon>
													</v-btn>
												</template>
												<span>Επαναφορά</span>
											</v-tooltip>
										</td>
									</tr>
								</template>
							</v-data-table>
							</v-col>
						</v-row>
					</v-col>
				</v-row>

			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import requests from "@/requests";
import utils from "@/utilities";

export default {
    name: "Homepage",
    data: () => ({
        selectedYear: null,
		search:'',
		costLimits:[],
		startingCostLimits:[],
		headers:[
			{text: 'Ίδρυμα', value: 'institutionName', align: 'center'},
			{text: 'Χρηματικό Όριο', value: 'costLimit', align: 'center'},
			{text: 'Όριο Τεμάχιων ανά Βιβλίο', value: 'amountLimit', align: 'center'},
			{text: 'Ενέργειες', value: '', align: 'center', sortable: false},
		]
    }),

    computed: {
        loggedUser: {
            get() {
                return this.$store.getters.homePageInformation.bookSupplier;
            }
        }
    },

    methods: {
    	saveOrderLimitDisabledCondition(val){
    		if(val==null){
    			return true;
			}
			if(/^\s*$/.test(val)){
				return true;
			}
			if(!(/^\d+(\.\d\d?)?$/.test(val))){
				return true;
			}
			return false;
		},

        getLibraryOrdersLimits() {
			this.$store.commit('setLoadingModal', true);
			requests.get('rest/order-limits/' + this.selectedYear,  (resp) => {
				this.costLimits = JSON.parse(JSON.stringify(resp));
				this.startingCostLimits = JSON.parse(JSON.stringify(resp));
				this.$store.commit('setLoadingModal', false);
			});

        },

		changeYear(year){
			this.selectedYear = year;
			this.getLibraryOrdersLimits();
		},

		resetCostLimit(index) {
			document.activeElement.blur();
			// Reset the cost limit of the item at the given index to its starting value
			this.costLimits[index].costLimit = this.startingCostLimits[index].costLimit;
		},

        saveOrderLimit(item) {
			document.activeElement.blur();
			this.$store.commit('setLoadingModal', true);
			requests.put('rest/order-limits', item,  (resp) => {
				this.costLimits = JSON.parse(JSON.stringify(resp));
				this.startingCostLimits = JSON.parse(JSON.stringify(resp));
				this.$store.commit('setLoadingModal', false);
			});
        },

		getExcel(){
			this.$store.commit('setLoadingModal', true);
			requests.getReports('rest/order-limits/excel/' + this.selectedYear)
		},

    },

	created(){
		this.selectedYear = this.$store.getters.yearsInfo.yearsList[0].year == this.$store.getters.homePageInformation.configuration.ACTIVE_YEAR? this.$store.getters.yearsInfo.yearsList[0].year : this.$store.getters.yearsInfo.yearsList[1].year;
		this.getLibraryOrdersLimits();
	},
}
</script>

<style scoped>
::v-deep .centered-text .v-input__control {
	display: flex !important;
	align-items: center !important;
}

::v-deep .centered-text .v-input__slot {
	display: flex !important;
	justify-content: center !important;
}

::v-deep .centered-text .v-input__slot input {
	text-align: center !important;
}
</style>